/* eslint-disable no-underscore-dangle */
// I'm disabling the above rule as there's no guarantee we can refactor _root from the component.
import React from 'react';
import AvatarEditor from 'react-avatar-editor';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import PropTypes from 'prop-types';
import Modal from '../../Modal/ReactBootstrapModal';
import { transparentPng } from '../../../utils/constants';

import styles from './photoEditor.scss';

const ratios = {
    player_profile: 1,
    player_banner: 2.83,
    club_banner: 2.83,
    event_banner: 1.83,
    hero_image: 2.44,
    club_sponsor_logo: 2.5,
    club_profile: 1,
};

class PhotoEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: 0,
            scale: 1.2,
            imageLoaded: false,
            submitting: false,
            loadError: null,
        };
        this.handleCropImage = this.handleCropImage.bind(this);
        this.setEditorRef = this.setEditorRef.bind(this);
        this.handleImageReady = this.handleImageReady.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
        this.handleCloseEditor = this.handleCloseEditor.bind(this);
        this.handleLoadFailure = this.handleLoadFailure.bind(this);
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener('resize', this.updateDimensions);
    }

    componentDidUpdate(prevProps) {
        const { imageUrl } = this.props;
        if (imageUrl !== prevProps.imageUrl && imageUrl === transparentPng) {
            //  TODO: Refactor this to remove setting state inside of CDU
            // eslint-disable-next-line
            this.setState({ imageLoaded: false, submitting: false });
        }
        this.updateDimensions();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    setEditorRef(editor) {
        this.editor = editor;
    }

    handleCloseEditor() {
        if (!this.state.submitting) {
            this.props.closeEditor();
            this.setState({
                scale: 1.2,
                imageLoaded: false,
                submitting: false,
            });
        }
    }

    updateDimensions() {
        if (this._root && this._root.offsetWidth !== this.state.width) {
            this.setState({
                width: this._root.offsetWidth,
            });
        }
    }

    async handleCropImage() {
        if (this.editor) {
            this.setState({ submitting: true });
            const rect = this.editor.getCroppingRect();
            await this.props.uploadCropData(
                {
                    cropRectangle: rect,
                    tempPhotoUri: this.props.imageUrl,
                },
            );
            this.setState({
                submitting: false,
            }, this.handleCloseEditor);
        }
    }

    handleImageReady() {
        if (this.editor.props.image !== transparentPng) {
            this.setState({ imageLoaded: true });
        }
    }

    handleLoadFailure() {
        this.setState({ loadError: 'Error loading image' });
    }

    render() {
        const inputProps = {
            change: e => {
                this.setState({
                    scale: e.target.value,
                });
            },
        };
        const onClickBackdrop = (e) => {
            e.preventDefault();
            return false;
        };
        const getBorder = () => {
            if (this.props.type === 'player_profile' || this.props.type === 'club_profile') {
                return 0;
            }
            return 0.05 * this.state.width;
        };
        const getSize = () => {
            let max = 800;
            if (this.props.type === 'player_profile' || this.props.type === 'club_profile') {
                max = 400;
            }
            const h = Math.max(0, Math.min(max, this.state.width - getBorder() * 2));
            return [h, h / ratios[this.props.type]];
        };
        const size = getSize();
        let modalHeaderTitle = 'Edit Banner Photo';
        switch (this.props.type) {
            case 'player_profile':
            case 'club_profile':
                modalHeaderTitle = 'Edit Profile Photo';
                break;
            case 'club_sponsor_logo':
                modalHeaderTitle = 'Edit Club Sponsor Logo';
                break;

            default:
                break;
        }
        const { 'data-testid': dataTestId } = this.props;
        return (
            <React.Fragment>
                <Modal visible={this.props.showEditor} onClickBackdrop={onClickBackdrop} dialogClassName="modal-lg">
                    <div className="modal-header" data-testid={dataTestId ? `${dataTestId}.header` : undefined}>
                        <div className="text-medium" data-testid={dataTestId ? `${dataTestId}.title` : undefined}>{modalHeaderTitle}</div>
                        <div className="close-icon" onClick={this.handleCloseEditor} data-testid={dataTestId ? `${dataTestId}.close-btn` : undefined}><i className="utr utr-close" /></div>
                    </div>
                    <div className={`modal-body`}>
                        <div>
                            <div className="text-center" ref={ref => { this._root = ref; }} style={{ minHeight: '160px' }}>
                                <AvatarEditor
                                    ref={this.setEditorRef}
                                    image={this.props.imageUrl}
                                    width={size[0]}
                                    height={size[1]}
                                    border={getBorder()}
                                    color={[255, 255, 255, 0.6]} // RGBA
                                    scale={this.state.scale}
                                    rotate={0}
                                    borderRadius={this.props.radius}
                                    onImageReady={this.handleImageReady}
                                    onLoadFailure={this.handleLoadFailure}
                                    style={!this.state.imageLoaded ? { transition: 'height 0.5s' } : {}}
                                />
                                {(!this.props.imageUrl || !this.state.imageLoaded) && this.props.showEditor
                                    ? (
                                        <div className={styles.loaderWrapper}>
                                            <div className={styles.loader} />
                                        </div>
                                    )
                                    : null}
                            </div>
                            <div className={styles.editContainer}>
                                <div className="slider-small slider-gray">
                                    <div className="wrapper">
                                        <ReactBootstrapSlider
                                            {...inputProps}
                                            value={this.state.scale}
                                            max={2}
                                            min={1}
                                            step={0.01}
                                            disabled={(!this.state.imageLoaded || this.state.submitting) ? 'disabled' : ''}
                                        />
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-primary text-uppercase"
                                    onClick={this.handleCropImage}
                                    disabled={!this.state.imageLoaded || this.state.submitting}
                                    data-testid={dataTestId ? `${dataTestId}.save-btn` : undefined}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal visible={!!this.state.loadError} dialogClassName="modal-lg">
                    <div className="modal-header" data-testid={dataTestId ? `${dataTestId}.error.header` : undefined}>
                        <div className="text-medium" data-testid={dataTestId ? `${dataTestId}.error.title` : undefined}>Image Load Error</div>
                        <div className="close-icon" onClick={() => this.setState({ loadError: null })} data-testid={dataTestId ? `${dataTestId}.error.close-btn` : undefined}><i className="utr utr-close" /></div>
                    </div>
                    <div className={`modal-body`}>
                        <div>
                            <div className="text-center">
                                <p data-testid={dataTestId ? `${dataTestId}.error.message` : undefined}>{this.state.loadError}</p>
                            </div>
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-primary text-uppercase float-right"
                                    onClick={() => this.setState({ loadError: null })}
                                    data-testid={dataTestId ? `${dataTestId}.error.ok-btn` : undefined}
                                >
                                    Ok
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

PhotoEditor.propTypes = {
    type: PropTypes.oneOf([
        'player_profile',
        'player_banner',
        'club_banner',
        'event_banner',
        'hero_image',
        'club_sponsor_logo',
        'club_profile',
    ]),
    radius: PropTypes.number,
};

PhotoEditor.defaultProps = {
    radius: 0,
    type: {},
};

export default PhotoEditor;
